import { IScopeTopicWithClauses } from "@/api";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AccordionSummary, Box, Stack, Typography } from "@mui/material";
import { useMemo } from "react";

interface TopicAccordionSummaryProps {
    topic: IScopeTopicWithClauses;
}

export const TopicAccordionSummary = ({
    topic,
}: TopicAccordionSummaryProps) => {
    const clauseCount = useMemo(() => {
        const ids = new Set<number>();
        for (const section of topic.sections) {
            for (const sc of section.clauses) {
                ids.add(sc.clause.id);
            }
        }
        return ids.size;
    }, [topic.sections]);

    return (
        <AccordionSummary
            expandIcon={
                <ExpandMoreIcon
                    sx={{
                        color: "#94a3b8",
                        fontSize: 18,
                        transition: "color 0.15s ease",
                    }}
                />
            }
            sx={{
                minHeight: 52,
                px: 2,
                transition: "background 0.15s ease",
                "&:hover": {
                    bgcolor: "rgba(34, 56, 118, 0.02)",
                    "& .MuiSvgIcon-root": {
                        color: "#64748b",
                    },
                },
                "&.Mui-expanded": {
                    minHeight: 52,
                },
                "& .MuiAccordionSummary-content": {
                    my: 1.5,
                    "&.Mui-expanded": {
                        my: 1.5,
                    },
                },
            }}
        >
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: "100%", pr: 0.5 }}
            >
                <Typography
                    sx={{
                        fontWeight: 600,
                        fontSize: "0.9375rem",
                        color: "#0f172a",
                        letterSpacing: "-0.02em",
                    }}
                >
                    {topic.name}
                </Typography>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        minWidth: 24,
                        height: 24,
                        borderRadius: "50%",
                        bgcolor: "#e2e8f0",
                    }}
                >
                    <Typography
                        component="span"
                        sx={{
                            fontSize: "0.75rem",
                            fontWeight: 500,
                            color: "#64748b",
                        }}
                    >
                        {clauseCount}
                    </Typography>
                </Box>
            </Stack>
        </AccordionSummary>
    );
};
